import React from 'react';

import EditorSearchIcon from '@atlaskit/icon/glyph/editor/search';

import { Button } from '@qality/common-components/src/atoms/Button';
import { TextField } from '@qality/common-components/src/atoms/TextField';
import { Issue } from '@qality/common-components/src/molecules/Issue';
import { NoIssuesFoundInfo } from '@qality/common-components/src/molecules/NoIssuesFoundInfo';
import { SpinnerLoader } from '@qality/common-components/src/molecules/SpinnerLoader';

import {
  CreateNewWrapperStyled,
  IssuesListRowStyled,
  IssuesListStyled,
  SearchBugStyled,
} from './SearchBug.styled';

export const SearchBugView = ({
  onCreateIssue,
  onClickIssue,
  searchValue,
  onChangeText,
  issuesList = [],
  isLoadingSearchOptions,
}: any) => {
  const handleChangeSearch = (e) => {
    onChangeText(e.target.value);
  };

  return (
    <SearchBugStyled>
      <TextField
        value={searchValue}
        onChange={handleChangeSearch}
        suffixComponent={<EditorSearchIcon />}
        placeholder='Search bugs...'
      />

      <CreateNewWrapperStyled>
        <Button onClick={onCreateIssue} appearance='link'>
          + Create New
        </Button>
      </CreateNewWrapperStyled>

      <IssuesListStyled>
        {isLoadingSearchOptions ? (
          <SpinnerLoader text='Loading issues' shouldHideContent={false} />
        ) : (
          <>
            {issuesList.map((issue) => (
              <IssuesListRowStyled
                onClick={onClickIssue?.bind(this, issue.issueId)}
                key={issue.issueKey}
              >
                <Issue
                  issueKey={issue.issueKey}
                  iconSrc={issue.iconSrc}
                  title={issue.title}
                />
              </IssuesListRowStyled>
            ))}
          </>
        )}
        {!isLoadingSearchOptions && issuesList.length < 1 && (
          <NoIssuesFoundInfo />
        )}
      </IssuesListStyled>
    </SearchBugStyled>
  );
};
